module.exports = __webpack_public_path__ + "static/catalogue3-f3ba6ab5bcdc5b9bf312f629d7b5fb4b.png";